import { Grid2, Paper } from "@mui/material";
import CustomTable from "./CustomTable";


const ChartsDataTable = ({ chartsData }) => {
    const columns = [
        {
            name: "Category",
            id: "category",
        },
        {
            name: "Value",
            id: "value",
        },
    ];

    const handleCopy = () => {
        const charts = chartsData.map(item => `${item.category},${item.value}`).join('\n');
        navigator.clipboard.writeText(charts).then(function () {
            alert("Charts Data copied to clipboard!");
        }).catch(function (error) {
            console.error('Unable to copy Excel data: ', error);
        });
    }

    const handleDownloadCSV = () => {
        const csvContent = 'Category,Value\n' + chartsData.map(item => `${item.category},${item.value}`).join('\n');

        // Create a blob from the CSV content
        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

        // Create a link to download the CSV file
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', 'chart_data.csv');

        // Append the link and trigger the download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    return (
        <div className="m-4">
            <Grid2 display={"grid"} rowGap={2}>
                <div className="flex justify-center font-bold text-xl charts-data-container">Charts Data</div>
                <CustomTable
                    columns={columns}
                    data={chartsData} // Pass the `chartData` as `data`
                    count={chartsData.length}
                    headerBackgroundColor={'#bcccdc'}
                    enableAlternateRowColor={true}
                    hidePagination
                />
                <div className="flex justify-between gap-2">
                    <button
                        className="copy-button"
                        onClick={handleCopy}
                        style={{
                            marginTop: "10px",
                            padding: "8px 16px",
                            backgroundColor: "#4CAF50",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                    >
                        Copy to clipboard
                    </button>
                    <button
                        className="copy-button"
                        onClick={handleDownloadCSV}
                        style={{
                            marginTop: "10px",
                            padding: "8px 16px",
                            backgroundColor: "#4CAF50",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer",
                        }}
                    >
                        Download as CSV
                    </button>
                </div>
            </Grid2>
        </div>
    );
};

export default ChartsDataTable;
